module.exports = __webpack_public_path__ + "static/media/Modal.aa03ad37.jpg";